"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const dealer_1 = require("../../shared/dealer");
exports.NAMESPACE = 'Culligan.Api.V1.Dealer.Profile.Schema';
exports.Profile = effect_1.Schema.Struct({
    locations: effect_1.Schema.propertySignature(effect_1.Schema.Array(dealer_1.Location)).annotations({
        description: 'Dealer locations whose id is in the user dealerIds, ordered by id ascending. Empty when the user has no dealerIds.',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Profile`,
    description: 'Dealer profile of the current user',
});
//# sourceMappingURL=schema.js.map